export default class OfficeUserShow {
  constructor(){
    this.bindHotKeys()
  }

  // uses jquery-hotkeys lib in n2-styles
  bindHotKeys() {
    $(document).on('keydown', null, 'meta+a ctrl+a', function(e){
      this.selectAll(e)
    }.bind(this));
  }
  /**
   * Hotkey action that allow the user to use cmd+a or ctrl+a
   * to select all of the article text to copy to
   * their clipboard
  */
  selectAll(e) {
    e.preventDefault();
    let $text = $('.js-article-text');
    let range, selection;
    // http://stackoverflow.com/questions/985272/selecting-text-in-an-element-akin-to-highlighting-with-your-mouse
    if (document.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText($text[0]);
        range.select();
    } else if (window.getSelection) {
        selection = window.getSelection();
        range = document.createRange();
        range.selectNodeContents($text[0])
        selection.removeAllRanges();
        selection.addRange(range);
    }
  }
}
